import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-facebook';
export var ID = 'icon-facebook';
/* eslint-disable max-len */

export var SVGFacebook = function SVGFacebook() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-334.000000, -392.000000)",
    fill: "#3A599B"
  }, React.createElement("g", {
    transform: "translate(334.000000, 392.000000)"
  }, React.createElement("path", {
    d: "M10.7823491,15.3333333 L10.7823491,9.70506866 L12.6880819,9.70506866 L12.9733953,7.49243446 L10.7823491,7.49243446 L10.7823491,6.07976529 C10.7823491,5.43915605 10.9602167,5.00261673 11.8788884,5.00261673 L13.0505738,5.00206742 L13.0505738,3.02311111 C12.8478772,2.99619476 12.1523915,2.93593508 11.3432529,2.93593508 C9.65394956,2.93593508 8.49748015,3.96705119 8.49748015,5.86069913 L8.49748015,7.49243446 L6.58691336,7.49243446 L6.58691336,9.70506866 L8.49748015,9.70506866 L8.49748015,15.3333333 L1.66666667,15.3333333 C1.11438192,15.3333333 0.666666667,14.8856181 0.666666667,14.3333333 L0.666666667,1.66666667 C0.666666667,1.11438192 1.11438192,0.666666667 1.66666667,0.666666667 L14.3333333,0.666666667 C14.8856181,0.666666667 15.3333333,1.11438192 15.3333333,1.66666667 L15.3333333,14.3333333 C15.3333333,14.8856181 14.8856181,15.3333333 14.3333333,15.3333333 L10.7823491,15.3333333 Z"
  })))));
};
/* eslint-disable max-len */

var Facebook = function Facebook(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGFacebook
  });
};

Facebook.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Facebook;